import BackgroundVideo from '../../../resources/scripts/helpers/background-video';

class BrixHero {
  static init(...parameters) {
    return new BrixHero(...parameters);
  }

  constructor(block) {
    if (block) {
      const backgroundVideoWrapper = document.querySelector(`#${block.id} > .background > .video`);
      const arrow = block.querySelector('.arrow-wrapper');
      if (arrow) {
        const addAnimation = (entries) => {
          if (entries[0].isIntersecting && !arrow.classList.contains('-animate')) {
            arrow.classList.add('-animate');
          }
        };

        const options = {
          root: null,
          rootMargin: '0px',
          threshold: 1.0,
        };

        const observer = new IntersectionObserver(addAnimation, options);
        observer.observe(arrow);
      }

      if (backgroundVideoWrapper) {
        BackgroundVideo.init(block);
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-hero', BrixHero.init);
}
